<form [formGroup]="requestForm" class="col-12 lg:col-12 md:col-12 form-group" novalidate>
  <div class="grid">
    <div class="col-12 lg:col-12 md:col-12">
      <div class="p-field col-12 md:col-12">
        <div>{{'Desc' | translate}}</div>
        <textarea formControlName="desc" rows="4" cols="57" pInputTextarea></textarea>
      </div>
    </div>
  </div>
  <div class="grid">
    @if (item.type==='ComboCustom') {
      <div class="p-field col-12 md:col-6" >
        <div class="center-text">{{'List_ValD' | translate}}</div>
        <textarea class="textarea-wrapper" formControlName="displayValue" rows="16" cols="57"></textarea>
      </div>
    }
    <div class="p-field col-12" [ngClass]="item.type==='ComboCustom' ? 'md:col-6' : 'md:col-12'">
      <div [ngClass]="item.type==='ComboCustom' ? 'center-text' : ''">{{'List_ValS' | translate}}</div>
      <textarea class="textarea-wrapper" formControlName="useValue" rows="16" cols="57"></textarea>
    </div>
  </div>
</form>

<div class="col-12 lg:col-12 md:col-12 align-right">
  <button
    (click)="cancel()"
    type="button"
    class="p-button-primary p-button-outlined p-button p-component p-button-text-only btn-square margin"
    >
    {{'Cancel' | translate}}
  </button>
  <button
    (click)="validate()"
    type="button"
    class="p-button p-component p-button-text-only btn-square margin"
    >
    {{'Valid' | translate}}
  </button>
</div>
